import {
  UPDATE_GRADE_START,
  UPDATE_GRADE_SUCCESS,
  UPDATE_GRADE_FAILED
} from '../../actionTypes/index.js'

import gradeAxios from '../../../../axios/gradeCriteria'
import { enqueueSnackbar } from '../../../actions/alert'

export const updateGrade = (targetId, payload) => {
  if (!targetId) {
    return updateGradeFailed()
  }
  return dispatch => {
    dispatch(updateGradeStart())
    gradeAxios
      .put(`${targetId}`, payload)
      .then(response => {
        if (response.status === 200) {
          dispatch(updateGradeSuccess())
          dispatch(
            enqueueSnackbar({
              message: 'Update Grade Success',
              options: { variant: 'success' }
            })
          )
        }
      })
      .catch(error => {
        console.log(error, { ...error })
        dispatch(updateGradeFailed())
        dispatch(
          enqueueSnackbar({
            message: 'Update Grade Failed',
            options: { variant: 'error' }
          })
        )
      })
  }
}

const updateGradeStart = () => {
  return {
    type: UPDATE_GRADE_START
  }
}

const updateGradeSuccess = () => {
  return {
    type: UPDATE_GRADE_SUCCESS
  }
}

const updateGradeFailed = () => {
  return {
    type: UPDATE_GRADE_FAILED
  }
}
